import React, { useState } from "react";
import cx from "classnames";
import FullScreenMediaViewer from "pages/Profile/components/common/FullScreenMediaViewer";
import MediaPlayer from "pages/Profile/components/common/MediaPlayer";
import { PlayIcon, VolumeHighIcon } from "assets";
import { MediaItem } from "pages/Profile/types";
import { MediaType } from "shared-types";

interface Props {
  toggleFullScreenViewer?: () => void;
  selectedIndex?: number;
  media: MediaItem[];
}

const iconStyles =
  "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 drop-shadow-icon text-white";

const MediaViewer = ({
  toggleFullScreenViewer,
  selectedIndex,
  media,
}: Props) => {
  const [fullScreenMediaIndex, setFullScreenMediaIndex] = useState(
    selectedIndex ?? 0
  );
  const selectedMedia = media[fullScreenMediaIndex];

  return (
    <FullScreenMediaViewer onToggle={toggleFullScreenViewer}>
      <div className="flex min-h-screen flex-col items-center justify-center p-4 sm:p-8">
        <div className="relative flex aspect-video w-full max-w-6xl flex-col items-center">
          <MediaPlayer
            src={selectedMedia?.src}
            poster={selectedMedia?.poster}
            title={selectedMedia?.title}
          />
        </div>
        <div className="mt-4 flex flex-wrap justify-center gap-3">
          {media.map((media, index) => {
            return (
              <button
                key={`media-button-${index}`}
                className={cx(
                  "relative aspect-video h-24 rounded-lg text-white opacity-60",
                  "bg-[linear-gradient(180deg,#2741E8_0%,#20016B_100%)] hover:opacity-100",
                  {
                    "opacity-100 ring-2 ring-white":
                      fullScreenMediaIndex === index,
                  }
                )}
                onClick={() => setFullScreenMediaIndex(index)}
              >
                {media.mediaType === MediaType.Video ? (
                  <>
                    <img
                      src={media.poster}
                      alt={media.title}
                      className="h-full w-full rounded-lg object-cover"
                    />
                    <PlayIcon height={24} width={24} className={iconStyles} />
                  </>
                ) : (
                  <VolumeHighIcon
                    height={24}
                    width={24}
                    className={iconStyles}
                  />
                )}
                <div className="absolute bottom-0 w-full truncate p-2">
                  {media.title}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </FullScreenMediaViewer>
  );
};

export default MediaViewer;
